"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Defines the style of the tab summary
 */
var AddinTabSummaryStyle;
(function (AddinTabSummaryStyle) {
    // No style (default)
    AddinTabSummaryStyle[AddinTabSummaryStyle["None"] = 0] = "None";
    // Show summary text next to the tab caption (the value shown will be the 'summary' property)
    AddinTabSummaryStyle[AddinTabSummaryStyle["Text"] = 1] = "Text";
})(AddinTabSummaryStyle = exports.AddinTabSummaryStyle || (exports.AddinTabSummaryStyle = {}));
//# sourceMappingURL=addin-tab-summary-style.js.map